import Filters, { registerModuleFilters } from '@/utils/input/filters';
import { CoreEnums } from '@/utils/domain/constants';
import { createEnumOptions } from '@/utils/core/data-transformation';
import { getEnumNamespace } from '@/utils/infrastructure';

const { BaseFilters } = Filters;

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
};

const StatusFilter = {
  ...BaseFilters.EnumFilter,
  name: 'status',
  label: 'applications.text.teamsMessage.status',
  enumNamespace: getEnumNamespace(CoreEnums.MessageStatus, 'Status'),
  enumSource: CoreEnums.MessageStatus,
  options: createEnumOptions(CoreEnums.MessageStatus, 'applications.text.teamsMessageStatus'),
};

const ConversationDestinationTypeFilter = {
  ...BaseFilters.EnumFilter,
  name: 'conversationDestinationType',
  label: 'applications.text.teamsMessage.conversationDestinationType',
  enumNamespace: getEnumNamespace(CoreEnums.TeamsConversationDestinationType, 'Teams'),
  enumSource: CoreEnums.TeamsConversationDestinationType,
  options: createEnumOptions(
    CoreEnums.TeamsConversationDestinationType,
    'applications.text.teamsConversationDestinationType',
    { casing: 'camel' },
  ),
};

const MessageFormatFilter = {
  ...BaseFilters.EnumFilter,
  name: 'messageFormat',
  label: 'applications.text.teamsMessage.messageFormat',
  enumNamespace: getEnumNamespace(CoreEnums.TeamsMessageFormat, 'Teams'),
  enumSource: CoreEnums.TeamsMessageFormat,
  options: createEnumOptions(CoreEnums.TeamsMessageFormat, 'applications.text.teamsMessageFormat', {
    casing: 'camel',
  }),
};

const AgentFilter = {
  ...BaseFilters.RemoteFilter,
  name: 'agentId',
  label: 'applications.text.teamsMessage.agent',
  apiRoute: 'ai/agent/manageable',
  params: {
    select: 'id,name',
    filter: 'isActive eq true',
    orderBy: 'name asc',
  },
};

export const filtersConfig = [
  CreatedDateFilter,
  StatusFilter,
  ConversationDestinationTypeFilter,
  MessageFormatFilter,
  AgentFilter,
];

registerModuleFilters('teamsMessageTrace', filtersConfig);
